module.exports = __webpack_public_path__ + "toGroom-we-p-b.8e00a535.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-p-b.jpg
// module id = OZFN
// module chunks = 0